import { render } from "./DoorpostBanner.vue?vue&type=template&id=5e446bdd&scoped=true"
import script from "./DoorpostBanner.vue?vue&type=script&lang=js"
export * from "./DoorpostBanner.vue?vue&type=script&lang=js"

import "./DoorpostBanner.vue?vue&type=style&index=0&id=5e446bdd&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e446bdd"]])

export default __exports__